import { writable } from 'svelte/store'
import api from '../../app/api'
import { navigate } from "svelte-routing";

const initState = {
    data: null,
    isLoaded: false,
    isLoading: false,
    isLogged: false,
    errorGetData: null,
    errorLoginStatus: null
}

function userStore() {
    const user = writable(initState)
    if (user.isLoading) return
    user.update(() => ({
        ...user,
        isLoading: true
    }))
    function tryLogin() {
        api.tryLogin().then(result => {
            user.update(() => ({
                ...user,
                isLogged: true,
                isLoaded: true,
                isLoading: false
            }))
        })
    }

    function login(credentials) {
        if (user.isLoading) return
        user.update(() => ({
            ...user,
            isLoading: true
        }))
        api.login(credentials).then(
            result => {
                user.update(() => ({
                    ...user,
                    isLogged: true,
                    isLoaded: true,
                    isLoading: false,
                    errorLoginStatus: null
                }))
                navigate('/')
            },
            error => {
                user.update(() => ({
                    ...user,
                    isLoaded: true,
                    isLoading: false,
                    errorLoginStatus: error.status
                }))
            }
        )
    }
    function logout() {
        api.logout().then(
            () => {
                user.update(() => ({
                    ...user,
                    isLogged: false
                }))
                navigate('/login')
            }
        )
    }
    return {
        subscribe: user.subscribe,
        logout,
        login,
        tryLogin
    }
}

export default userStore()

